import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { useVersionCheck } from "src/shared/hooks/useVersionCheck";

const TOAST_ID = "new-frontend-version-available";

function NewVersionToast() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <span>새 버전이 배포되었습니다. 새로고침 후 이용해 주세요.</span>
      <div style={{ display: "flex", alignSelf: "flex-end", gap: 8 }}>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "4px 12px",
            border: "none",
            borderRadius: 6,
            background: "#1976d2",
            color: "#fff",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          새로고침
        </button>
        <button
          type="button"
          onClick={() => toast.dismiss(TOAST_ID)}
          style={{
            padding: "4px 12px",
            border: "1px solid #d0d5dd",
            borderRadius: 6,
            background: "#fff",
            color: "#475467",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
}

/**
 * Jenkins 배포로 새 프론트 빌드(version.json)가 감지되면
 * 닫히지 않는 토스트로 새로고침을 안내합니다.
 */
export default function VersionWatcher() {
  const showToast = useCallback(() => {
    if (toast.isActive(TOAST_ID)) return;
    toast.info(<NewVersionToast />, {
      toastId: TOAST_ID,
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    });
  }, []);

  useVersionCheck(showToast);

  return null;
}
